<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
            <el-tabs type="border-card" style="margin-top: 10px;margin-right: 5px;">
                <el-tab-pane :label="index" v-for="(item,index) in setting" :key="index">
                    <el-tabs type="border-card">
                        <el-tab-pane label="BKKZone">

                            <q-select
                                filled
                                hide-selected
                                label="ค้นหาจังหวัด"
                                v-model="setting[index].bkkZone"
                                multiple
                                fill-input
                                input-debounce="500"
                                use-input
                                @filter="filterProvince"
                                :options="province"
                                style="width: 300px; padding-bottom: 10px"
                            >
                                <template v-slot:option="scope">
                                <q-item
                                    v-bind="scope.itemProps"
                                    v-on="scope.itemEvents">
                                    <q-item-section >
                                    <q-item-label> {{scope.opt}}</q-item-label>
                                    </q-item-section>
                                    <q-item-section avatar v-if="scope.selected">
                                        <q-icon name="done" />
                                    </q-item-section>
                                </q-item>
                                </template>
                                <template v-slot:no-option>
                                    <q-item>
                                        <q-item-section class="text-italic text-grey">
                                        ไม่พบข้อมูล
                                        </q-item-section>
                                    </q-item>
                                </template>
                            </q-select>
                            <div class="scroller">
                                <div style="margin-top:10px;" v-for="(tag,indexTag) in setting[index].bkkZone" :key="indexTag">
                                    <el-button-group class="tagGroup">
                                        <el-button class="bFrist" type="primary" size="small" round>{{tag}} <i class="el-icon-arrow-left"></i></el-button>
                                        <el-button type="primary" icon="el-icon-close" size="small" round @click="handleRemoveProvince(tag,index,indexTag)"></el-button>
                                    </el-button-group>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="RomoteZone">
                            <h3 class="h3margin"><b>ค่าบริการพื้นที่ห่างไกลบวกเพิ่ม <el-input-number size="mini" v-model="setting[index].remoteZone['cost']" :min="0" :precision="2"></el-input-number> บาท</b></h3><br>

                            <q-select
                                filled
                                hide-selected
                                label="ค้นหารหัสไปรษณีย์"
                                v-model="setting[index].zipcodeArr"
                                multiple
                                fill-input
                                input-debounce="500"
                                use-input
                                @filter="filterZipcode"
                                @remove="removeZipcode($event,index)"
                                :options="zipcode"
                                style="width: 300px; padding-bottom: 10px"
                            >
                                <template v-slot:option="scope">
                                <q-item
                                    v-bind="scope.itemProps"
                                    v-on="scope.itemEvents">
                                    <q-item-section >
                                    <q-item-label> {{scope.opt}}</q-item-label>
                                    </q-item-section>
                                    <q-item-section avatar v-if="scope.selected">
                                        <q-icon name="done" />
                                    </q-item-section>
                                </q-item>
                                </template>
                                <template v-slot:no-option>
                                    <q-item>
                                        <q-item-section class="text-italic text-grey">
                                        ไม่พบข้อมูล
                                        </q-item-section>
                                    </q-item>
                                </template>
                            </q-select>
                            <div class="scroller">
                                <div style="margin-top:10px;" v-for="(tag,indexTag) in setting[index].zipcodeArr" :key="indexTag">
                                    <el-button-group class="tagGroup">
                                        <el-button class="bFrist" type="primary" size="small" round>{{tag}}<i class="el-icon-arrow-left"></i></el-button>
                                        <el-button type="primary" icon="el-icon-close" size="small" round @click="handleRemoveZipcode(tag,index,indexTag)"></el-button>
                                    </el-button-group>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="Cod">
                            <h2><b>ค่าบริการเก็บเงินปลายทาง</b></h2>
                            <div style="margin-bottom:0px;margin-left:20px;">
                                ขั้นต่ำ  <el-input-number size="mini" v-model="setting[index].cod.minimumCod.value" :min="0" :precision="2"></el-input-number> บาท
                            </div>
                            <br>
                            <div style="margin-left:20px;">
                                ค่าบริการ
                                <div style="margin-left:35px;">
                                    <div style="margin-top:15px">
                                        <el-radio v-model="setting[index].cod.serviceCharge.type" :label="0" >
                                            <el-input-number size="mini" v-model="setting[index].cod.serviceCharge.percent" :min="0" :precision="2" :disabled="setting[index].cod.serviceCharge.type !== 0"></el-input-number> เปอร์เซ็น
                                        </el-radio>
                                    </div>
                                    <br>
                                    <div>
                                        <el-radio v-model="setting[index].cod.serviceCharge.type" :label="1" >
                                            <el-input-number size="mini" v-model="setting[index].cod.serviceCharge.value" :min="0" :precision="2" :disabled="setting[index].cod.serviceCharge.type !== 1"></el-input-number> บาท
                                        </el-radio>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import fgApi from '@/services/fillgoods'
export default {
    name: 'CourierRatecardSetting',
    props: {
        setting: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            value: [],
            list: [],
            loading: false,
            loadingZipcode: false,
            province: [],
            zipcode: []
        }
    },
    methods: {
        removeZipcode (val, key) {
            if (this.setting[key].remoteZone.hasOwnProperty(val.value[0])) {
                delete this.setting[key].remoteZone[val.value[0]]
            }
        },
        async filterZipcode (val, update, abort) {
            try {
                const param = {
                    limit: null,
                    offset: 0,
                    search: val
                }
                const result = await fgApi.order.searchListZipcode(param)
                let zipcodeResult = []
                if (result.success) {
                    if (result.data.zipcode.length > 0) {
                        zipcodeResult = result.data.zipcode.map(e => e.zipcode)
                    } else {
                        zipcodeResult = []
                    }
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: 'Api Error!'
                    })
                    zipcodeResult = []
                }
                update(() => {
                    console.log(zipcodeResult)
                    this.zipcode = zipcodeResult
                })
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
        },
        async filterProvince (val, update, abort) {
            try {
                const param = {
                    search: val
                }
                const result = await fgApi.order.searchProvince(param)
                let provinceResult = []
                if (result.success) {
                    console.log(result)
                    if (result.data.provinces.length > 0) {
                        provinceResult = result.data.provinces.map(e => e.provinceName)
                    } else {
                        provinceResult = []
                    }
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: 'Api Error!'
                    })
                    provinceResult = []
                }
                update(() => {
                    this.province = provinceResult
                })
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
        },
        handleRemoveProvince (val, key, index) {
            this.loading = true
            setTimeout(() => {
                this.loading = false
                this.setting[key].bkkZone.splice(this.setting[key].bkkZone.indexOf(val), 1)
            }, 200)
        },
        handleRemoveZipcode (val, key, index) {
            this.loading = true
            setTimeout(() => {
                this.loading = false
                if (this.setting[key].remoteZone.hasOwnProperty(val)) {
                    delete this.setting[key].remoteZone[val]
                }
                this.setting[key].zipcodeArr.splice(this.setting[key].zipcodeArr.indexOf(val), 1)
            }, 200)
        }
    }
}
</script>

<style lang="scss">
.provinceSelected {
    width: 267px;
  .el-select__tags {
    span {
      display: none;
    }
  }
}
.tagBkk{
    display: block;
    width: 244px;
    height: 32px;
    margin-top:10px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.el-input-number__decrease{
    display: none;
}
.el-input-number__increase{
    display: none;
}
.el-input-number--mini .el-input__inner {
    padding-left: 0px;
    padding-right: 0px;
}
.h3margin{
    margin-block-start: 0em;
    margin-block-end: 0em;
}
.tagGroup{
    .el-icon-arrow-left{
        visibility: hidden;
    }
    .bFrist{
        width: 230px;
    }
}
.scroller {
    margin-top: 10px;
    width: 100%;
    height: 250px;
    overflow-y: scroll;
}
</style>
